import { Component, OnInit, inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { MainLayout } from '../../layouts/main-layout';
import { NuestrasSucursales } from '../../components/sucursales/nuestras-sucursales';
import { MarginWrapper } from '../../layouts/margin-wrapper';

@Component({
  selector: 'allas-sucursales',
  imports: [MainLayout, MarginWrapper, NuestrasSucursales],
  template: `
    <allas-main-layout [showPopularSections]="true" [showNewsletter]="true">
      <!-- <h1
        class="text-2xl xl:text-4xl fs-condensed font-medium p-4 text-gray-800"
      >
        NUESTRAS SUCURSALES
      </h1> -->
      <!-- Hero Section -->
      <section class="bg-[#f3f4f6] text-white py-6 xl:py-16">
        <div class="container mx-auto px-4">
          <!-- Grid de 2 columnas -->
          <div class="grid grid-cols-1 lg:grid-cols-12 items-center gap-8">
            <!-- Columna izquierda -->
            <div class="lg:col-span-7 order-2 lg:order-1">
              <h1
                class="italic fs-condensed justify-center text-center text-6xl md:text-8xl font-bold"
              >
                <span class="text-[#003f83]">Nuestras </span>
                <span class="text-red-600">Sucursales</span>
              </h1>

              <div class="max-w-4xl">
                <p
                  class="text-xl justify-center text-center xl:justify-start xl:text-left font-light xl:font-normal xl:text-3xl mb-12 w-full text-appBlack fs-condensed pl-12"
                >
                  Encuentra la sucursal más cercana a ti y disfruta de nuestros
                  servicios en Repuestos y Accesorios de calidad a los mejores
                  precios de Honduras.
                </p>
                <!-- Imagen en mobile -->
                <div
                  class="lg:hidden flex justify-center items-center order-1 mb-8"
                  onclick="console.log('KOMETHA ESTUVO AQUÍ')"
                >
                  <img
                    src="/images/stores/assets/nuestras-sucursales-banner.webp"
                    alt="Nuestras Sucursales"
                    class="w-full max-w-2xl h-auto object-contain rounded-lg"
                  />
                </div>
                <div
                  class="flex flex-row gap-5 justify-center xl:justify-end xl:pr-[6rem]"
                >
                  <a
                    href="/encuentra-tu-tienda"
                    class="bg-red-600 hover:bg-red-700 px-3 py-2 xl:px-4 rounded-lg transition-colors text-sm xl:text-sm fs-condensed flex items-center justify-center flex-1 xl:flex-none"
                  >
                    ENCUENTRA TU TIENDA
                  </a>
                  <a
                    href="tel:+50422834540"
                    class="py-2 bg-white border border-blue-600 text-blue-600 hover:bg-gray-100 px-3 xl:px-8 rounded-lg transition-colors text-sm xl:text-sm fs-condensed flex items-center justify-center flex-1 xl:flex-none"
                  >
                    LLAMAR AHORA
                  </a>
                </div>
              </div>
            </div>

            <!-- Columna derecha (solo desktop) -->
            <div
              class="hidden lg:flex lg:col-span-5 justify-center items-center order-2"
              onclick="console.log('KOMETHA ESTUVO AQUÍ')"
            >
              <img
                src="/images/stores/assets/nuestras-sucursales-banner.webp"
                alt="Nuestras Sucursales"
                class="w-full max-w-2xl h-auto object-contain rounded-lg"
              />
            </div>
          </div>
        </div>
      </section>
      <allas-margin-wrapper>
        <!-- Sucursales Grid -->
        <section class="py-16 bg-white">
          <div class="container mx-auto px-4">
            <div class="text-center mb-4">
              <h2
                class="text-xl xl:text-2xl font-bold text-gray-800 mb-4 fs-condensed"
              >
                Selecciona una sucursal para conocer su ubicación exacta y
                servicios disponibles
              </h2>
            </div>
            <allas-nuestras-sucursales></allas-nuestras-sucursales>
          </div>
        </section>

        <!-- CTA Section -->
        <section class="relative text-white py-16 overflow-hidden">
          <div
            class="absolute inset-0 bg-center bg-no-repeat"
            style="background-image: url('/images/stores/assets/pablo_mobile.webp'); background-size: 120% 80%;"
          ></div>
          <div
            class="hidden lg:block absolute inset-0 bg-cover bg-center bg-no-repeat"
            style="background-image: url('/images/stores/assets/pablo.webp');"
          ></div>
          <div
            class="absolute inset-0 bg-black bg-opacity-0 xl:bg-opacity-50"
          ></div>
          <div class="relative container mx-auto px-4">
            <!-- Espacio arriba para la imagen en mobile -->
            <div class="lg:hidden h-40 w-full"></div>

            <div
              class="flex flex-col lg:flex-row items-center justify-center gap-1 xl:gap-8"
            >
              <div class="text-center flex-1 max-w-4xl lg:mr-8">
                <h2
                  class="text-4xl xl:text-6xl font-bold mb-4 tracking-wider fs-condensed"
                >
                  ¿NECESITAS AYUDA?
                </h2>
                <p
                  class="text-base xl:text-xl mb-4 xl:mb-8 max-w-2xl mx-auto font-thin"
                >
                  Contáctanos para obtener información sobre horarios, productos
                  disponibles o cualquier consulta sobre nuestras sucursales.
                </p>
              </div>
              <div class="flex-shrink-0">
                <a
                  href="/encuentra-tu-tienda"
                  class="bg-white text-black hover:bg-gray-100 px-4 xl:px-6 py-2 xl:py-4 rounded-lg transition-colors fs-condensed flex items-center justify-center"
                >
                  ENCUENTRA TU TIENDA
                </a>
              </div>
            </div>
          </div>
        </section>
      </allas-margin-wrapper>
    </allas-main-layout>
  `,
})
export class Sucursales implements OnInit {
  private title = inject(Title);
  private meta = inject(Meta);

  ngOnInit() {
    this.setMetaTags();
  }

  private setMetaTags() {
    const pageTitle = 'Nuestras Sucursales | Allas Repuestos';
    const description =
      'Encuentra la sucursal más cercana de Allas Repuestos en Honduras. Repuestos y accesorios de calidad con servicios profesionales y envío a domicilio.';
    const keywords =
      'sucursales, Allas Repuestos, repuestos Honduras, tiendas físicas, ubicaciones, servicios automotrices, envío a domicilio, instalación';
    const imageUrl = 'https://www.allasrepuestos.com/logos/isotipo.webp';

    // --- Título de la página ---
    this.title.setTitle(pageTitle);

    // --- Meta Descripción ---
    this.meta.updateTag({
      name: 'description',
      content: description,
    });

    // --- Palabras Clave ---
    this.meta.updateTag({
      name: 'keywords',
      content: keywords,
    });

    // --- Open Graph Tags ---
    this.meta.updateTag({ property: 'og:title', content: pageTitle });
    this.meta.updateTag({ property: 'og:description', content: description });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ property: 'og:image', content: imageUrl });
    this.meta.updateTag({
      property: 'og:image:alt',
      content: 'Logo de Allas Repuestos',
    });

    // --- Twitter Tags ---
    this.meta.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image',
    });
    this.meta.updateTag({ name: 'twitter:title', content: pageTitle });
    this.meta.updateTag({ name: 'twitter:description', content: description });
    this.meta.updateTag({ name: 'twitter:image', content: imageUrl });

    // --- Icono del sitio (favicon / logo principal) ---
    this.meta.updateTag({
      name: 'icon',
      content: imageUrl,
    });
  }
}
